import { ReactElement } from 'react';

export type NotificationVariants =
	| 'default'
	| 'error'
	| 'success'
	| 'warning'
	| 'info'
	| undefined;

export interface Notification {
	/**
	 * A custom button or action you want placed to the right of your notification. Defaults to 'X'.
	 */
	action: ReactElement;
	/**
	 * A custom key used for programmatically dismissing notifications. Default generates its
	 * own hash.
	 */
	key: string;
	/**
	 * A callback that gets fired when the notification gets closed.
	 */
	onClose: Function;
	/**
	 * The text you want displayed in your notification.
	 */
	text: string;
	/**
	 * How long you want before your notification autohides in milliseconds. Put 0 if
	 * you don't want your notification to autohide. Defaults to 3000 milliseconds.
	 */
	timeout: number;
	/**
	 * Whether or not the notification should be displayed right now
	 */
	dismissed: boolean;
	/**
	 * The type of notification you are trying to display. Currently comes in success,
	 * warn, and error
	 */
	variant: NotificationVariants;
}

export interface NotificationOptions {
	/**
	 * A custom button or action you want placed to the right of your notification. Defaults to 'X'.
	 */
	action: ReactElement;
	/**
	 * A custom key used for programmatically dismissing notifications. Default generates its
	 * own hash.
	 */
	key: string;
	/**
	 * A callback that gets fired when the notification gets closed.
	 */
	onClose: Function;
	/**
	 * How long you want before your notification autohides in milliseconds. Put 0 if
	 * you don't want your notification to autohide. Defaults to 3000 milliseconds.
	 */
	timeout: number;
	/**
	 * Whether or not the notification should be displayed right now
	 */
	dismissed: boolean;
	/**
	 * The type of notification you are trying to display. Currently comes in success,
	 * warn, and error
	 */
	variant: NotificationVariants;
}

export type NotificationStoreState = Notification[];
